import React from 'react';
import styled from 'styled-components';
import { Button, ButtonProps } from './Button';
import { HudIconProps, HudIcon } from '../Icons/HudIcons';

const StyledButton = styled(Button)`
  padding: 8px;
`;

export type IconButtonProps = Omit<ButtonProps, 'children'> & {
  icon: HudIconProps['icon'];
};

export function IconButton({ icon, ...rest }: IconButtonProps) {
  const iconSize =
    rest.size === 'xs' ? '12px' : rest.size === 'sm' ? '14px' : '16px';

  return (
    <StyledButton {...rest}>
      <HudIcon icon={icon} size={iconSize} />
    </StyledButton>
  );
}
